import { redirect } from "react-router-dom";

const routeCheck = (params) => {
    if (localStorage.getItem("customer") === null)
        return redirect(`/customer-details/${params.rid}/${params.tid}`);
    
    return null;
}

export {routeCheck};